/**
 * Scroll-driven 3x3 technology block.
 * The cells start as one compact face and travel to eight positions around
 * the centre cell. The canvas uses the same positions for the lines behind it.
 */
(function () {
    const region = document.getElementById('ts-region');
    const stage = document.getElementById('ts-stage');
    const canvas = document.getElementById('ts-canvas');
    const core = document.getElementById('ts-core');
    const cells = Array.from(document.querySelectorAll('#tech-stack .ts-cell[data-i]'));
    if (!region || !stage || !canvas || !core || cells.length !== 9) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobileQuery = window.matchMedia('(max-width: 767px)');
    const tallViewportQuery = window.matchMedia('(min-width: 768px) and (max-width: 1100px) and (min-height: 900px)');
    const ctx = canvas.getContext('2d');
    const directions = [
        [-0.707, -0.707], [0, -1], [0.707, -0.707],
        [-1, 0], [0, 0], [1, 0],
        [-0.707, 0.707], [0, 1], [0.707, 0.707]
    ];

    let width = 0;
    let height = 0;
    let cellSize = 0;
    let dpr = 1;
    let progress = 0;
    let geometry = [];
    let scrollFrame = null;

    function resizeCanvas() {
        const rect = stage.getBoundingClientRect();
        width = rect.width;
        height = rect.height;
        if (!width || !height) return;
        cellSize = cells[0].getBoundingClientRect().width;
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.round(width * dpr);
        canvas.height = Math.round(height * dpr);
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        updatePositions(progress);
        draw();
    }

    function updatePositions(nextProgress) {
        if (!width || !height) return;
        progress = nextProgress;
        const pitch = cellSize * 1.1;
        const networkRadius = Math.min(width, height) * 0.46;

        geometry = cells.map((cell, index) => {
            const col = index % 3 - 1;
            const row = Math.floor(index / 3) - 1;
            const compactX = col * pitch;
            const compactY = row * pitch;
            const networkX = directions[index][0] * networkRadius;
            const networkY = directions[index][1] * networkRadius;
            const x = compactX + (networkX - compactX) * progress;
            const y = compactY + (networkY - compactY) * progress;
            cell.style.setProperty('--ts-x', x.toFixed(2) + 'px');
            cell.style.setProperty('--ts-y', y.toFixed(2) + 'px');
            return { x: width / 2 + x, y: height / 2 + y };
        });

        core.style.setProperty('--ts-progress', progress.toFixed(3));
        stage.classList.toggle('ts-expanded', progress > 0.42);
    }

    function drawDiamond(x, y, angle, size) {
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(angle);
        ctx.beginPath();
        ctx.moveTo(size, 0);
        ctx.lineTo(0, size * 0.58);
        ctx.lineTo(-size, 0);
        ctx.lineTo(0, -size * 0.58);
        ctx.closePath();
        ctx.fillStyle = '#2563eb';
        ctx.fill();
        ctx.strokeStyle = 'rgba(255, 255, 255, 0.92)';
        ctx.lineWidth = 1.5;
        ctx.stroke();
        ctx.restore();
    }

    function draw() {
        if (!width || !height || geometry.length !== 9) return;
        ctx.clearRect(0, 0, width, height);
        if (progress < 0.04) return;

        const centre = geometry[4];
        const lineStart = cellSize * 0.56;

        directions.forEach((_, index) => {
            if (index === 4) return;
            const point = geometry[index];
            const dx = point.x - centre.x;
            const dy = point.y - centre.y;
            const distance = Math.hypot(dx, dy);
            if (distance < cellSize * 1.08) return;

            const angle = Math.atan2(dy, dx);
            const ux = Math.cos(angle);
            const uy = Math.sin(angle);
            const startDistance = lineStart;
            const lineAlpha = 0.58 + progress * 0.22;
            const markerSize = Math.max(6, cellSize * 0.095);
            // Place the diamond on the target square's edge. The square sits
            // above the canvas, hiding its outer tip like an ER connector.
            const markerDistance = distance - cellSize * 0.5;
            if (markerDistance <= startDistance) return;

            ctx.beginPath();
            ctx.moveTo(centre.x + ux * startDistance, centre.y + uy * startDistance);
            ctx.lineTo(centre.x + ux * markerDistance, centre.y + uy * markerDistance);
            ctx.strokeStyle = 'rgba(37, 99, 235, ' + lineAlpha + ')';
            ctx.lineWidth = 3.5;
            ctx.lineCap = 'round';
            ctx.stroke();

            drawDiamond(
                centre.x + ux * markerDistance,
                centre.y + uy * markerDistance,
                angle,
                markerSize
            );
        });
    }

    function scrollProgress() {
        const rect = region.getBoundingClientRect();
        const available = Math.max(1, rect.height - window.innerHeight);
        return Math.max(0, Math.min(1, -rect.top / available));
    }

    function update() {
        if (mobileQuery.matches || tallViewportQuery.matches) {
            updatePositions(0);
            draw();
            return;
        }
        const value = reduceMotion.matches ? 1 : scrollProgress();
        updatePositions(value);
        draw();
    }

    window.addEventListener('scroll', () => {
        if (scrollFrame) return;
        scrollFrame = requestAnimationFrame(() => {
            scrollFrame = null;
            update();
        });
    }, { passive: true });

    const onResize = () => {
        resizeCanvas();
        update();
    };
    if ('ResizeObserver' in window) {
        new ResizeObserver(onResize).observe(stage);
    } else {
        window.addEventListener('resize', onResize);
    }

    resizeCanvas();
    update();
})();
